<div class="sidebar" [class.collapsed]="collapsed" id="sidebar">
  <ul class="nav flex-column pt-2">
    <div class="nav-section-label">Core</div>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/dashboard" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-grid-fill"></i></span>
        <span class="menu-text">Dashboard</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/analytics" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-bar-chart-fill"></i></span>
        <span class="menu-text">Analytics</span>
      </a>
    </li>

    <div class="nav-section-label">Management</div>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/app-users" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-people-fill"></i></span>
        <span class="menu-text">Users</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/content" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-camera-video-fill"></i></span>
        <span class="menu-text">Content</span>
        <!-- <span class="nav-badge menu-text">12</span> -->
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/categories" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-tags-fill"></i></span>
        <span class="menu-text">Categories</span>
      </a>
    </li>

    <div class="nav-section-label">Config</div>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/engagement" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-lightning-fill"></i></span>
        <span class="menu-text">Engagement Rules</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/gifts" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-gift-fill"></i></span>
        <span class="menu-text">Gifts</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/reactions" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-heart-fill"></i></span>
        <span class="menu-text">Reactions</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/audio" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-music-note-beamed"></i></span>
        <span class="menu-text">Background Audio</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/music-library" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-music-note-list"></i></span>
        <span class="menu-text">Music Library</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/legal-pages" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-file-earmark-text-fill"></i></span>
        <span class="menu-text">Legal Pages</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/avatars" routerLinkActive="active">
        <span class="nav-icon"><i class="bi bi-file-earmark-person-fill"></i></span>
        <span class="menu-text">Avatars</span>
      </a>
    </li>
  </ul>

  <!-- <div class="sidebar-footer">
    <div class="avatar-circle">SA</div>
    <div>
      <div class="admin-name menu-text">Super Admin</div>
      <div class="admin-role menu-text">admin&#64;trendly.app</div>
    </div>
  </div> -->
</div>
